import ExtensionModel from './ExtensionModel';
import { backend } from '../../setup';

class CourseModel extends ExtensionModel {
	
	constructor( json:Object ){
		super( json );
	}

	get title():string{
		return this.get<string>( 'title' );	
	}
	
	get modelName():string{
		return this.get<string>( 'modelName' );	
	}

	get id():string {
		return this.get<string>( 'id' );
	}

	get description():string {
		return this.get<string>( 'description' );
	}

	get image():number {
		return this.get<number>( 'image' );
	}

	get level():number {
		return this.get<number>( 'level' );
	}

	get type():string {
		return this.get<string>( 'type' );
	}

	get form():string {
		return this.get<string>( 'form' );
	}
}

export default CourseModel;


backend.mapper.toModel.add( 'App\\Course', function( json ) {
	return new CourseModel( json );
});

backend.mapper.toJson.add( 'App\\Course', function( model:CourseModel ){
	return model.object();
})